var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttentions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attentions",
    transform: "translate(-158 -508)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    width: 60,
    height: 60,
    rx: 5,
    transform: "translate(158 508)",
    fill: "#f4f5fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_box_important",
    d: "M22,4A18,18,0,1,0,40,22,18.021,18.021,0,0,0,22,4Zm0,2.7A15.3,15.3,0,1,1,6.7,22,15.28,15.28,0,0,1,22,6.7Zm-.021,5.381A1.35,1.35,0,0,0,20.65,13.45v10.8a1.35,1.35,0,1,0,2.7,0V13.45a1.35,1.35,0,0,0-1.371-1.369ZM22,28.3a1.8,1.8,0,1,0,1.8,1.8A1.8,1.8,0,0,0,22,28.3Z",
    transform: "translate(166 516)",
    fill: "#325ae7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentions);
export default __webpack_public_path__ + "static/media/attentions.fb0a21a68f3a0d8a1e4c61f887d95d0b.svg";
export { ForwardRef as ReactComponent };